// Marca de Jugaly: una J que va a recoger una pelota (jugar)
// En tamaños pequeños el trazo es más grueso para que se siga leyendo.
export function LogoMark({ size = 24 }: { size?: number }) {
  const small = size <= 32;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true" className="text-accent">
      <path
        d={small ? 'M67 35 V58 A17 17 0 0 1 33 60' : 'M67 34 V58 A17 17 0 0 1 33 60'}
        fill="none"
        stroke="currentColor"
        strokeWidth={small ? 16 : 13}
        strokeLinecap="round"
      />
      <circle cx={small ? 39 : 40} cy={small ? 26 : 27} r={small ? 11.5 : 10} fill="currentColor" />
    </svg>
  );
}

export default function Logo() {
  return (
    <span className="inline-flex items-center gap-1.5">
      <LogoMark size={26} />
      <span className="text-[1.0625rem] font-semibold tracking-[-0.022em] text-ink">Jugaly</span>
    </span>
  );
}
